<template>
  <div>
    <div class="section-container">
      <div class="search-section">
        <p>กรุณาระบุข้อมูลที่ต้องการดาวน์โหลดรายงาน</p>
        <b-row class="date-section">
          <b-col cols="3">
            <label><strong>วันที่ชำระเงิน</strong></label>
            <div class="date-range-field">
              <b-input-group>
                <b-form-input
                  size="sm"
                  type="text"
                  :value="formatPurchaseDate"
                  placeholder="เลือกวันที่ชำระเงิน"
                  disabled
                />
                <b-input-group-prepend>
                  <b-button
                    size="sm"
                    variant="secondary"
                    @click="showCalendarRange(`purchase-date-${tabIndex}`)"
                  >
                    <b-icon icon="calendar-range"></b-icon>
                  </b-button>
                </b-input-group-prepend>
              </b-input-group>
              <DatePicker
                v-model="purchaseDate"
                locale="th"
                :id="`purchase-date-${tabIndex}`"
                style="
                    display: none;
                    float: right;
                    position: relative;
                    will-change: transform;
                    left: 0px;
                  "
                is-range
              />
            </div>
          </b-col>
          <b-col cols="3">
            <b-form-checkbox
              v-model="isAdvancedFilters"
              name="check-button"
              switch
              size="lg"
            >
              ค้นหาขั้นสูง
            </b-form-checkbox>
          </b-col>
        </b-row>
        <div v-if="isAdvancedFilters" class="search-section">
          <b-row>
            <b-col cols="3">
              <label><strong>สถาบัน</strong></label>
              <b-form-select
                v-model="selectedInstitute"
                :options="instituteList"
              ></b-form-select>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="3">
              <label><strong>รูปแบบคอร์ส</strong></label>
              <b-form-select
                v-model="selectedCourseType"
                :options="courseTypeList"
              ></b-form-select>
            </b-col>
            <b-col cols="3">
              <label><strong>ประเภทการรับหนังสือ</strong></label>
              <b-form-select
                v-model="selectedBookReceivingType"
                :options="bookReceivingType"
              ></b-form-select>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="3">
              <label><strong>วิชา</strong></label>
              <b-form-select
                v-model="selectedSubject"
                :options="subjectList"
              ></b-form-select>
            </b-col>
            <b-col cols="3">
              <label><strong>สาขา</strong></label>
              <b-form-select
                v-model="selectedInstituteBranch"
                :options="instituteBranchList"
                :disabled="selectedBookReceivingType === 'SHIPPING'"
              ></b-form-select>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="3">
              <label><strong>รหัสคอร์ส</strong></label>
              <b-form-input v-model="courseCode"></b-form-input>
            </b-col>
            <b-col cols="5">
              <label><strong>ชื่อคอร์ส</strong></label>
              <v-select
                v-if="!isLoadingCourses"
                :options="courseList"
                label="courseName"
                v-model="selectedCourse"
                placeholder="พิมพ์ชื่อคอร์สเรียนที่ต้องการค้นหา"
                :clearable="false"
              />
              <v-select v-else placeholder="กำลังโหลดข้อมูล..." />
            </b-col>
          </b-row>
        </div>
        <b-button @click="searchQuery()" class="search-btn" variant="primary">
          <b-icon icon="search"></b-icon>
          ค้นหาข้อมูล
        </b-button>
      </div>

      <div class="table-section">
        <div class="table-title">
          <p>
            <strong>รายละเอียด{{ menuTitle }}</strong>
            ข้อมูลทั้งหมด {{ bookDeliveryPurchaseList.length }} ข้อมูล
          </p>
          <b-button @click="generatePdf()" variant="primary">
            <b-icon icon="chevron-double-down"></b-icon>
            ดาวน์โหลดรายงาน pdf
          </b-button>
        </div>
        <p class="remark-text">
          หมายเหตุ : ระบบทำการ generate report เป็นไฟล์ pdf
          และดาวน์โหลดลงบนเครื่องของคุณ
        </p>
        <b-table
          id="book-delivery-purchase-report"
          :fields="fields"
          :items="bookDeliveryPurchaseList"
          :per-page="perPage"
          :current-page="currentPage"
          responsive
          style="font-size: 14px; border:hidden;"
          :busy="isDataTableLoading"
          hover
          bordered
          show-empty
        >
          <template slot="table-busy" class="text-center text-danger my-2">
            <Loading />
          </template>
          <template #empty>
            <p class="text-center py-3">ไม่มีข้อมูล</p>
          </template>
          <template v-if="bookDeliveryPurchaseList.length > 0" #bottom-row>
            <b-td :colspan="tabIndex === 0 ? 2 : 4" variant="secondary">
              รวมทั้งหมด
            </b-td>
            <b-td variant="secondary" class="text-center">
              {{ totalBooks }}
            </b-td>
          </template>
        </b-table>
        <b-row class="mt-3" v-if="bookDeliveryPurchaseList.length > 0">
          <b-col cols="6">
            <form class="form-inline">
              <div class="form-group mb-2">
                <label>แสดง</label>
              </div>
              <div class="form-group ml-2 mb-2">
                <b-form-select v-model="perPage" size="sm">
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="15">15</option>
                  <option value="30">30</option>
                  <option value="50">50</option>
                </b-form-select>
              </div>
              <div class="form-group ml-2 mb-2">
                <label>
                  จาก
                  {{ bookDeliveryPurchaseList.length }}
                  รายการ
                </label>
              </div>
            </form>
          </b-col>
          <b-col cols="6" v-if="bookDeliveryPurchaseList.length > 0">
            <nav class="float-right">
              <b-pagination
                v-model="currentPage"
                :per-page="perPage"
                :total-rows="bookDeliveryPurchaseList.length"
                aria-controls="book-delivery-purchase-report"
                last-number
              >
              </b-pagination>
            </nav>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import vSelect from "vue-select";
import Loading from "@/components/shared/Loading";
import moment from "moment";
import api from "@/services/api";
import dateMixin from "@/components/pages/analytics/shared/mixins/date.js";
import generateAttendanceReportPdfMixin from "../../../../mixins/generate-attendance-report-pdf-mixin";
import bookDeliveryPurchaseByBookReport from "../../../../mixins/book-delivery-purchase-by-book-report";
import bookDeliveryPurchaseByCourseReport from "../../../../mixins/book-delivery-purchase-by-course-report";
import { mapActions, mapGetters } from "vuex";

export default {
  mixins: [
    dateMixin,
    generateAttendanceReportPdfMixin,
    bookDeliveryPurchaseByBookReport,
    bookDeliveryPurchaseByCourseReport,
  ],
  components: { DatePicker, vSelect, Loading },
  props: ["tabIndex", "menuTitle"],
  data() {
    const currentDate = new Date();

    return {
      comId: this.$store.state.Company.companyInfo.id,
      moment: moment,
      purchaseDate: {
        start: "",
        end: "",
      },
      isAdvancedFilters: false,
      selectedInstitute: "",
      instituteList: [{ value: "", text: "ไม่ระบุ" }],
      selectedCourseType: "",
      courseTypeList: [
        { value: "", text: "ทั้งหมด" },
        { value: "ONSITE", text: "คอร์สเรียนรอบสอนสด" },
        { value: "ONLINE", text: "คอร์สเรียนออนไลน์" },
      ],
      selectedBookReceivingType: "",
      bookReceivingType: [
        { value: "", text: "ทั้งหมด" },
        { value: "PICKUP", text: "รับที่สถาบัน" },
        { value: "SHIPPING", text: "จัดส่งที่บ้าน" },
      ],
      selectedSubject: "",
      subjectList: [{ value: "", text: "ทั้งหมด" }],
      selectedInstituteBranch: "",
      instituteBranchList: [{ value: "", text: "ทั้งหมด" }],
      courseCode: "",
      isLoadingCourses: false,
      courseList: [{ courseName: "คอร์สทั้งหมด" }],
      selectedCourse: "",
      isDataTableLoading: false,
      bookDeliveryPurchaseList: [],
      perPage: 5,
      currentPage: 1,
      isDisableDownloadReportBtn: false,
      year: currentDate.getFullYear(),
      month: currentDate.getMonth() + 1,
      thaiMonths: [
        "มกราคม",
        "กุมภาพันธ์",
        "มีนาคม",
        "เมษายน",
        "พฤษภาคม",
        "มิถุนายน",
        "กรกฎาคม",
        "สิงหาคม",
        "กันยายน",
        "ตุลาคม",
        "พฤศจิกายน",
        "ธันวาคม",
      ],
      pdfOption: {
        orientation: "p",
        format: "a4",
        unit: "px",
        lineHeight: 1.5,
        putOnlyUsedFonts: true,
      },
      pdfConfig: {
        typo: {
          header: 16,
          large: 18,
          normal: 14,
          small: 12,
          extraSmall: 10,
          chartHeader: 18,
        },
        margin: {
          t: 40,
          b: 20,
          l: 40,
          r: 40,
          tChart: 10,
          tHeaderChart: 24,
          bHeaderTable: 5,
        },
        endLarge: 25,
        endNormal: 12,
        endRow: 18,
        endLegend: 32,
      },
    };
  },
  computed: {
    ...mapGetters("BookManagement", [
      "purchaseDeliveryReportByBook",
      "purchaseDeliveryReportByCourse",
    ]),
    userInfo() {
      return JSON.parse(localStorage.getItem("user"));
    },
    currentProfile() {
      return this.getCurrentProfile(this.userInfo.profiles);
    },
    fields() {
      if (this.tabIndex === 0) {
        return [
          {
            label: "รหัสหนังสือ",
            key: "book_code",
            thClass: "text-center text-nowrap",
            formatter: (value) => {
              return value || "-";
            },
          },
          {
            label: "ชื่อหนังสือ",
            key: "book_name",
            thClass: "text-nowrap",
          },
          {
            label: "จำนวน (เล่ม)",
            key: "bookCount",
            thClass: "text-center text-nowrap",
            tdClass: "text-center",
          },
        ];
      } else if (this.tabIndex === 1) {
        return [
          {
            label: "รหัสคอร์ส",
            key: "courseCode",
            thClass: "text-center text-nowrap",
            formatter: (value) => {
              return value || "-";
            },
          },
          {
            label: "หลักสูตร",
            key: "courseName",
            thClass: "text-nowrap",
          },
          {
            label: "รับที่สถาบัน",
            key: "pickupCount",
            thClass: "text-center text-nowrap",
            tdClass: "text-center",
          },
          {
            label: "จัดส่งที่บ้าน",
            key: "shippingCount",
            thClass: "text-center text-nowrap",
            tdClass: "text-center",
          },
          {
            label: "จำนวน (เล่ม)",
            key: "totalCount",
            thClass: "text-center text-nowrap",
            tdClass: "text-center",
          },
        ];
      }
      return [];
    },
    formatPurchaseDate() {
      return this.getFormattedRange(
        this.purchaseDate.start,
        this.purchaseDate.end,
        "purchase-date",
      );
    },
    selectedSubjectText() {
      const selected = this.subjectList.find(
        (item) => item.value === this.selectedSubject,
      );

      return selected ? selected.text : "ทั้งหมด";
    },
    selectedBookReceivingTypeText() {
      const selected = this.bookReceivingType.find(
        (item) => item.value === this.selectedBookReceivingType,
      );

      return selected ? selected.text : "ทั้งหมด";
    },
    selectedBranchText() {
      if (this.selectedBookReceivingType === "SHIPPING") {
        return "-";
      } else {
        const selected = this.instituteBranchList.find(
          (item) => item.value === this.selectedInstituteBranch,
        );
        return selected ? selected.text : "ทั้งหมด";
      }
    },
    instituteName() {
      if (this.comId == 1000001) {
        return "สถาบันกวดวิชาเคมี อ.อุ๊";
      } else if (this.comId == 1000002) {
        return "สถาบันกวดวิชาแอพพลายด์ฟิสิกส์";
      } else if (this.comId == 1000003) {
        return "สถาบันกวดวิชาไบโอบีม";
      }
      return "-";
    },
    totalBooks() {
      return this.bookDeliveryPurchaseList.reduce((sum, row) => {
        let bookAmount = this.tabIndex === 0 ? row.bookCount : row.totalCount;
        return sum + (Number(bookAmount) || 0);
      }, 0);
    },
  },
  async mounted() {
    let subjects = [];
    let courses = [];

    this.setDefaultDates();
    await this.fetch({
      startDate: this.purchaseDate.start,
      endDate: this.purchaseDate.end,
    });

    await api.get(`/v1/courses/academic-data`).then(({ data }) => {
      subjects = data.data.subjects.map((item) => {
        return { value: item.st_id, text: item.st_name };
      });
    });
    this.subjectList.push(...subjects);

    await api.get(`v1/companies/${this.comId}/courses`).then(({ data }) => {
      courses = data.data;
      this.isLoadingCourses = false;
    });
    this.courseList.push(...courses);

    let branch = [];
    if (this.comId == 1000001) {
      // chemou
      branch = [
        { value: "พญาไท", text: "พญาไท" },
        { value: "นครสวรรค์", text: "นครสวรรค์" },
        { value: "ราชบุรี", text: "ราชบุรี" },
        { value: "ศรีนครินทร์", text: "ศรีนครินทร์" },
      ];
    } else if (this.comId == 1000002 || this.comId == 1000003) {
      // appliedphysics, biobeam
      branch = [{ value: "พญาไท", text: "พญาไท" }];
    }
    this.instituteBranchList.push(...branch);
  },
  methods: {
    ...mapActions("BookManagement", [
      "fetchPurchaseDeliveryReportByBook",
      "fetchPurchaseDeliveryReportByCourse",
    ]),
    async fetch(params) {
      this.isDataTableLoading = true;

      if (this.tabIndex === 0) {
        try {
          await this.fetchPurchaseDeliveryReportByBook(params);
        } finally {
          this.bookDeliveryPurchaseList = this.purchaseDeliveryReportByBook;
          this.isDataTableLoading = false;
        }
      }

      if (this.tabIndex === 1) {
        try {
          await this.fetchPurchaseDeliveryReportByCourse(params);
        } finally {
          this.bookDeliveryPurchaseList = this.purchaseDeliveryReportByCourse;
          this.isDataTableLoading = false;
        }
      }

      this.isDataTableLoading = false;
    },
    async searchQuery() {
      let branch =
        this.selectedBookReceivingType === "SHIPPING"
          ? null
          : this.selectedInstituteBranch;

      let params = {
        courseType: this.selectedCourseType,
        courseCode: this.courseCode,
        courseName:
          this.selectedCourse?.courseName === "คอร์สทั้งหมด"
            ? null
            : this.selectedCourse?.courseName,
        stId: this.selectedSubject || null,
        pickupLocation: branch,
        bdType: this.selectedBookReceivingType,
        startDate: this.purchaseDate.start
          ? moment(this.purchaseDate.start).format("YYYY-MM-DD")
          : "",
        endDate: this.purchaseDate.end
          ? moment(this.purchaseDate.end).format("YYYY-MM-DD")
          : "",
      };
      await this.fetch(params);
    },
    generatePdf() {
      if (this.tabIndex === 0) {
        this.generateBookDeliveryPurchaseByBookReportPdf();
      } else if (this.tabIndex === 1) {
        this.generateBookDeliveryPurchaseByCourseReportPdf();
      }
    },
    getCurrentProfile(profiles) {
      const requestCompany = this.$route.params.company;
      if (requestCompany) {
        let currentCompany = profiles.find(
          (data) => data.company.url === requestCompany,
        );
        if (currentCompany) return currentCompany;
      } else if (localStorage.getItem("ComId")) {
        const currentComId = localStorage.getItem("ComId");
        let currentCompany = profiles.find(
          (data) => data.company.id == currentComId,
        );
        if (currentCompany) return currentCompany;
      }

      return profiles[0];
    },
    setDefaultDates() {
      const dateFormat = "YYYY-MM-DD";
      const currentDate = moment();
      const ninetyDaysAgo = moment(currentDate).subtract(90, "days");

      this.purchaseDate.start = ninetyDaysAgo.format(dateFormat);
      this.purchaseDate.end = currentDate.format(dateFormat);
    },
    getFormattedRange(startDate, endDate, calendarId) {
      if (!startDate) return "";

      const rangeCalendar = document.getElementById(calendarId);
      if (rangeCalendar && rangeCalendar.style.display === "inline-block") {
        this.showCalendarRange(calendarId);
      }

      const start = moment(startDate).format("DD/MM/YYYY");
      const end = moment(endDate).format("DD/MM/YYYY");
      return `${start} - ${end}`;
    },
    showCalendarRange(calendarId) {
      let rangeCalendar = document.getElementById(calendarId);
      if (rangeCalendar.style.display == "inline-block") {
        rangeCalendar.style.display = "none";
      } else {
        rangeCalendar.style.display = "inline-block";
      }
    },
  },
};
</script>

<style scoped lang="scss">
.section-container,
.search-section {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

.search-section {
  .date-section {
    align-items: flex-end;
  }

  .date-range-field,
  .date-field {
    .form-control:disabled {
      background-color: #fff;
    }
  }

  .search-btn {
    width: fit-content;
  }
}

.table-section {
  display: flex;
  flex-direction: column;
  gap: 25px;

  .table-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
  }

  .remark-text {
    color: #ffc107;
  }

  .table-secondary {
    font-family: "Prompt", sans-serif;
  }
}
/* Calendar */
.vc-container {
  position: absolute !important;
  right: 0 !important;
  left: initial !important;
  margin-right: 13px;
  z-index: 99;
}

/* Target the input search and its placeholder */
::v-deep .vs__search,
::v-deep .vs__search::placeholder {
  margin: 0;
  padding: 3px 3px 2px;
  font-size: 14px;
}
</style>

<style>
/* text field height */
.date-range-field .form-control,
.vs__dropdown-toggle {
  height: 38px;
}

.vs__dropdown-toggle {
  align-items: center;
}

.vs__clear {
  margin-bottom: 6px;
}

.custom-select {
  height: 38px !important;
  padding: 0 1.75rem 0 0.75rem;
  font-size: 14px !important;
}

.custom-switch.b-custom-control-lg .custom-control-label {
  font-size: 16px !important;
  line-height: 2 !important;
}
</style>
